<template>
  <div>
    <h3 class="title">{{title}}</h3>
    <el-form label-width="100px" :model="formData" ref="formData">
      <div class="card">
        <el-form-item label="名称" prop="menuType">
          <el-select v-model="formData.menuType" clearable="" placeholder="请选择名称" @input="testSX" style="width:90%;" :disabled="disabled">
            <el-option v-for="(item,index) in optionsStatus" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="formData.menuName" placeholder="请输入内容" @input="testSX" style="width:90%;"></el-input>
        </el-form-item>
      </div>
      <div class="footer">
        <el-form-item>
          <el-button type="danger" @click="resetForm('formData')">取 消</el-button>
          <el-button type="primary" @click="doAddgoods('formData')">确 定</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  props: ['code', 'formData'],
  data() {
    return {
      optionsStatus: this.$store.state.optionsStatus,
      title: '',
      disabled: false,
    }
  },
  created() {
    if (this.code == 0) {
      this.title = '新增美容外科手术表'
      this.disabled = false
    } else if (this.code == 1) {
      this.title = '编辑美容外科手术表'
      this.disabled = true
    }
  },
  methods: {
    testSX() {
      this.$forceUpdate()
    },///bs/register/createRegisterMenu
    doAddgoods(formData) {
      console.log(this.code);
      let createBy = Lockr.get("skinEmpId");
      this.formData.createBy = createBy
      //   新增数据
      if (this.code == 0) {
        this.$refs[formData].validate((valid) => {
          api.requestQuiet("/register/createRegisterMenu", this.formData, (res) => {
            if (res.result == true) {
              _g.toast("success", '新增成功!');
              this.$emit('add-comment')
              this.$emit('closeDialog')
            } else {
              _g.toast("error", '新增失败!');
            }
          }, (err) => {
            this.loading = false
          })
        })
      } else if (this.code == 1) {//修改数据
        this.$refs[formData].validate((valid) => {
          api.requestQuiet("/register/createRegisterMenu", this.formData, (res) => {
            if (res.result == true) {
              _g.toast("success", '修改成功!');
              this.$emit('add-comment')
              this.$emit('closeDialog')
            } else {
              _g.toast("error", '修改失败!');
            }
          }, (err) => {
            this.loading = false
          })
        })
      }

    },
    resetForm() {
      this.$emit('closeDialog')
    },

  }
}
</script>
<style scoped>
.footer {
  display: flex;
  justify-content: space-around;
  margin-top: 60px;
}
.sure {
  margin-left: 50px;
}
.title {
  text-align: center;
  margin-bottom: 30px;
}
.footer >>> .el-form-item__content {
  margin-left: 0 !important;
}
</style>